const config = {
  API_BASE_URL: "/prosapiens-cms/public/api",
};

export default config;
